import React from 'react'
import { useTranslation } from 'react-i18next'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ServiceInner from '../Components/Services/ServiceInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function Service() {
    const { t } = useTranslation();
    
    return (
        <div>
            <SEO 
                translationKey="seo.service"
                url="/service"
            />
            <HeaderOne />
            <Breadcrumb
                title={t('nav.services')}
            />
            <ServiceInner />
            <FooterFour />
            <ScrollToTop />
        </div>
    )
}

export default Service
